// extracted by mini-css-extract-plugin
export default {"link":"Logo_link__frBgz","logoWrapper":"Logo_logoWrapper__+gqZ5","logoText":"Logo_logoText__Au3Hd","logoImg":"Logo_logoImg__qxk69"};